import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const MonthlyARPUCharts: React.FC<ARPUChartProps> = ({ data }) => {
  const categories = data.map((pkg) => pkg.month_name);
  const totalUnits = data.map((pkg) => pkg.total_invoices);
  const totalSales = data.map((pkg) => pkg.average_revenue_per_user);

  const chartOptions: ApexOptions = {
    chart: {
      type: "line",
      height: 350,
    },
    plotOptions: {
      bar: {
        columnWidth: "55%",
      },
    },
    dataLabels: {
      enabled: true,
    },
    stroke: {
      show: true,
      width: [0, 2],
      curve: "smooth",
    },
    xaxis: {
      categories,
      labels: {
        rotate: -75, // Rotate the labels to display them vertically
        rotateAlways: true, // Ensure rotation is applied

        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        title: {
          text: "Total Users",
        },
      },
      {
        opposite: true,
        title: {
          text: "ARPU (PKR)",
        },
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: [
        {
          formatter: (val: number) => `${val} units`,
        },
        {
          formatter: (val: number) => ` ${val}`,
        },
      ],
    },
  };

  const series = [
    {
      name: "Total Units",
      type: "column",
      data: totalUnits,
    },
    {
      name: "ARPU (PKR)",
      type: "line",
      data: totalSales,
    },
  ];

  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={series}
        type="line"
        height={650}
      />
    </div>
  );
};

export default MonthlyARPUCharts;
